import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Stack,
  CircularProgress,
  Alert,
  Grid,
  Paper
} from "@mui/material";
import axios from "axios";
import { HeaderList } from "../../../Components/Header/HeaderList";
import WSSelectField from "../../../Components/Select/WSSelect";
import { useForm } from "react-hook-form";
import WSButton from "../../../Components/Button/WSButton";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import {
  callAPI,
  clearRequest,
  getLocalValue,
  LoacalVariables,
  Method
} from "../../../commonFunctions/CommonFunctions";

interface Props {
  onReferralSuccess: () => void;
}

const ReferralRegistration: React.FC<Props> = ({ onReferralSuccess }) => {
  const { control, handleSubmit } = useForm();
  const navigate = useNavigate();
  const { showMessage } = useSnackbar();

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<boolean>(false);

  const onSubmit = async (data: any) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const request = {
        ReferrerCustomerId: data.referrerCustomerId,
        ReferredCustomerId: data.referredCustomerId
      };
      const newRequest = clearRequest(request);

      const response: any = await callAPI(
        "loyalty/register-referral",
        Method.POST,
        newRequest
      );

      if (response) {
        showMessage(response?.message, "success");
        navigate("/loyalty/history");
      }
    } catch (err) {
      showMessage("Failed to register referral. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  const customerSource = {
    url: "customers/search",
    filter: [{
          "field": "FranchiseId",
          "operator": "eq",
          "value": getLocalValue(LoacalVariables.FranchiseId)
        }],
    sort: [],
    page: 1,
    pageSize: 100000
  };

  const handleTransform = (data: any) => {
    let allData: Array<any> = [];

    data.map((value: any) => {
      allData.push({ label: value.fullName, value: value.customerId });
    });

    return allData;
  };

  return (
   <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 1 }}>
    <HeaderList title="Refer & Earn" type="card" />

{success && (
  <Alert severity="success" sx={{ mb: 2 }}>
    Referral Registered Successfully!
  </Alert>
)}

{error && (
  <Alert severity="error" sx={{ mb: 2 }}>
    {error}
  </Alert>
)}

<Stack spacing={2}>
  <form onSubmit={handleSubmit(onSubmit)}>
    <Grid item sx={{ mb: 2 }}>
      <WSSelectField
        id="refererId"
        label={"Referrer Customer ID"}
        name="referrerCustomerId"
        control={control}
        source={customerSource}
        rules={{ required: "please select a referrer customer" }}
        transFormData={handleTransform}
      />
    </Grid>

    <Grid item sx={{ mb: 2 }}>
      <WSSelectField
        id="referredId"
        label={"Referred Customer ID"}
        name="referredCustomerId"
        control={control}
        source={customerSource}
        rules={{ required: "please select a referred customer" }}
        transFormData={handleTransform}
      />
    </Grid>

    <WSButton
      id="submitId"
      label="Register Referral"
      size="small"
      type="submit"
    />
  </form>
</Stack>
   </Paper>
  );
};

export default ReferralRegistration;
